<script setup lang="ts">
import type { NumeroRivista } from "@gasparigit/omnia-sdk";
import { link } from "~/lib/utils/contents";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: NumeroRivista;
  compact?: boolean;
  showAreas?: boolean;
  linkConfig?: CreateLinkConfig;
}>();
</script>

<template>
  <FrontContentItemsBaseItem
    v-bind="$props"
    :title="content.title"
    :date="content.published_at || content.created_at"
    :abstract="content.abstract"
    :show-areas="showAreas"
    :compact="compact"
    :link="link({ ...linkConfig, numeroRivista: content })"
    info-label="Numero Rivista"
  >
    <template #info />
    <template #preview>
      <div
        class="font-mono flex flex-col items-start justify-center text-base pe-4 border-e-2 border-primary mb-2 md:mb-0 min-w-28"
      >
        <span class="text-2xl text-primary font-semibold">{{
          content.number
        }}</span>
        <template v-if="content.published_at">
          <span>{{
            content.published_at.toLocaleString("default", { month: "long" })
          }}</span>
          <span>{{ content.published_at.getFullYear() }}</span>
        </template>
      </div>
    </template>
  </FrontContentItemsBaseItem>
</template>
